module.exports = __webpack_public_path__ + "static/Manrope-Bold-656753569aef606dd528cc6bdf672cdc.ttf";